import { css, type Theme } from "@emotion/react";

import { dimensions, layers } from "@styles";

export const linkWrapper = (theme: Theme) => css`
  display: flex;
  background-color: ${theme.surface.overlayTheme};
  padding: 0.75rem;
  border-radius: ${dimensions.borderRadius};
`;

export const input = (theme: Theme) => css`
  width: 17rem;
  border: 1px solid ${theme.system.borderBase};
  border-radius: ${dimensions.borderRadius};
  margin-right: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: ${theme.aviaryTypography.body.fontSize};
  &:active,
  &:focus {
    outline: none;
  }
`;

export const popperWrapper = (theme: Theme) => css`
  box-shadow: 0px 4px 16px ${theme.system.borderBase};
  border-radius: ${dimensions.borderRadius};
  z-index: ${layers.zIndexTopForeground};
  position: absolute;
  top: 0;
  left: 0;
`;

export const arrow = (theme: Theme) => css`
  position: absolute;
  width: 0;
  height: 0;
  margin-top: -8px;
  border-style: solid;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent ${theme.surface.overlayTheme} transparent;
`;
